<template>
    <div class="discount-box">
        <div class="show-text" @click="showDiscountBox">{{itemData.discount ? itemData.discount : "无"}}</div>

        <!--选择-->
        <cash-radio v-model="discountBoxState" :list-data="discountList" :value="discountValue" @checked="checkedDiscount" />
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import PopRadio from "@/model/PopRadio";
    import CashRadio from "@/model/Cash/CashRadio";
    export default {
        name: "CashDiscountSelect",
        components: {CashRadio, PopRadio},
        props: {
            itemData: {
                type: Object,
                default: () => ({discount_index: null}),
            },
            disModel: {
                type: Object,
                default: () => ({}),
            }
        },
        data: () => ({
            discountList: [],
            discountValue: 0,
            discountBoxState: false,
        }),
        mounted: function () {
            this.initDiscountList();
        },
        methods: {
            initDiscountList: function () {
                this.discountValue = obj.isEmpty(this.itemData.discount_index) ? 0 : this.itemData.discount_index;
                this.discountList = [
                    {
                        discount_type: 0,
                        label: "无折扣",
                        rightText: "",
                        value: -1,
                        disabled: false,
                    }
                ];

                if(!obj.isEmpty(this.disModel)) {
                    this.disModel.getDiscount(this.itemData.pro_id, this.itemData.pro_type).then(discount => {
                        if(!discount) return ;
                        discount.forEach((val, key) => {
                            this.discountList.push({
                                discount_type: val.discount_type,
                                label: val.title,
                                rightText: val.expire_datetime,
                                value: key,
                                disabled: val.sur_num === 0,
                            });
                        });
                    });
                }
            },
            showDiscountBox: function () {
                this.initDiscountList();
                this.discountBoxState = true;
            },
            checkedDiscount: function (checkedValue) {
                // this.disModel.updateDiscount(this.itemData, checkedValue);
                this.$emit("discountChange", checkedValue);
            }
        },
        watch: {

        }
    }
</script>

<style scoped>
    .discount-box{
        max-height: 42px;
    }
</style>
